import React from "react";

const Whatsapp = () => {
  return (
    <svg
      width="33"
      height="34"
      viewBox="0 0 33 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.50614 14.475C4.50565 16.2484 4.96902 17.98 5.85011 19.5062L4.42188 24.7209L9.75847 23.3216C11.2345 24.1252 12.8883 24.5462 14.5689 24.5463H14.5733C20.1212 24.5463 24.6373 20.0318 24.6397 14.4829C24.6408 11.7941 23.5946 9.2657 21.6938 7.36347C19.7934 5.4614 17.2659 4.41334 14.5729 4.41211C9.02432 4.41211 4.50843 8.92636 4.50614 14.475Z"
        fill="url(#paint0_linear_1110_171418)"
      />
      <g filter="url(#filter0_d_1110_171418)">
        <path
          d="M4.14613 14.4717C4.14556 16.3089 4.62553 18.1024 5.53804 19.6833L4.05859 25.0849L9.58654 23.6355C11.1097 24.466 12.8246 24.9038 14.5696 24.9045H14.5741C20.321 24.9045 24.9994 20.2276 25.0018 14.48C25.0028 11.6946 23.919 9.07529 21.9503 7.10491C19.9814 5.13477 17.3635 4.049 14.5741 4.04785C8.82612 4.04785 4.14842 8.72408 4.14613 14.4717ZM7.43814 19.411L7.23174 19.0834C6.36407 17.7037 5.9061 16.1094 5.90675 14.4723C5.90863 9.69508 9.79655 5.80839 14.5773 5.80839C16.8925 5.80937 19.0683 6.7119 20.7049 8.3494C22.3413 9.98706 23.2418 12.164 23.2412 14.4794C23.2391 19.2567 19.3511 23.1438 14.5741 23.1438H14.5706C13.0152 23.143 11.4897 22.7253 10.1593 21.9359L9.84269 21.7482L6.56229 22.6082L7.43814 19.411Z"
          fill="white"
        />
      </g>
      <path
        d="M11.9658 10.1145C11.7706 9.68063 11.5652 9.67187 11.3795 9.66427C11.2275 9.65772 11.0538 9.65821 10.8802 9.65821C10.7064 9.65821 10.4241 9.72358 10.1854 9.98414C9.94657 10.2449 9.27344 10.8752 9.27344 12.1571C9.27344 13.439 10.2071 14.6779 10.3373 14.8519C10.4676 15.0256 12.1398 17.7403 14.7881 18.7847C16.9891 19.6526 17.437 19.48 17.9147 19.4365C18.3925 19.3931 19.4563 18.8064 19.6734 18.198C19.8906 17.5896 19.8906 17.0682 19.8255 16.9592C19.7604 16.8507 19.5866 16.7855 19.326 16.6552C19.0654 16.5249 17.7844 15.8946 17.5456 15.8076C17.3067 15.7207 17.133 15.6773 16.9593 15.9382C16.7855 16.1987 16.2866 16.7855 16.1345 16.9592C15.9826 17.1334 15.8305 17.1551 15.57 17.0247C15.3093 16.894 14.4701 16.6192 13.4746 15.7317C12.7 15.041 12.1771 14.1882 12.0251 13.9273C11.8731 13.6668 12.0088 13.5256 12.1395 13.3958C12.2565 13.279 12.4001 13.0915 12.5305 12.9394C12.6604 12.7873 12.7038 12.6787 12.7907 12.5049C12.8776 12.331 12.8341 12.1788 12.7691 12.0485C12.7038 11.9182 12.1975 10.6296 11.9658 10.1145Z"
        fill="white"
      />
      <defs>
        <filter
          id="filter0_d_1110_171418"
          x="0.0585938"
          y="0.0478516"
          width="32.9414"
          height="33.0371"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="2" dy="2" />
          <feGaussianBlur stdDeviation="3" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1110_171418"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_1110_171418"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_1110_171418"
          x1="1015.31"
          y1="2035.29"
          x2="1015.31"
          y2="4.41211"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#1FAF38" />
          <stop offset="1" stop-color="#60D669" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default Whatsapp;
